import { Link } from "react-router-dom";

const LINKS = [["/", "Home"], ["/therapy", "The Therapy"], ["/training", "Training"], ["/case-studies", "Case Studies"], ["/about", "About"], ["/apply", "Apply"]];

export const Footer = () => (
  <footer style={{ background: "var(--kh-footer)", color: "var(--kh-footer-text)" }} data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-14 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
      <div className="md:col-span-5">
        <div className="text-3xl" style={{ fontFamily: "var(--kh-font-heading)", color: "var(--kh-footer-text)" }}>Kheiron Therapy</div>
        <p className="mt-5 text-sm leading-relaxed max-w-sm" style={{ color: "#CFC6BA" }}>A training institute for qualified clinicians in Post-Traumatic Growth and pre-emptive PTSD intervention. Not a directory. Not a clinic. A method.</p>
      </div>
      <div className="md:col-span-3">
        <div className="text-xs uppercase tracking-[0.22em] mb-5" style={{ fontFamily: "var(--kh-font-mono)", color: "#B5AB9F" }}>Navigate</div>
        <ul className="space-y-2 text-sm">
          {LINKS.map(([to, l]) => (
            <li key={to}><Link to={to} className="hover:text-[#D4A373] transition-colors" data-testid={`footer-${l.toLowerCase().replace(/\s/g, "-")}-link`}>{l}</Link></li>
          ))}
        </ul>
      </div>
      <div className="md:col-span-4">
        <div className="text-xs uppercase tracking-[0.22em] mb-5" style={{ fontFamily: "var(--kh-font-mono)", color: "#B5AB9F" }}>Clinical correspondence</div>
        <a href="mailto:training@kheirontherapy.com" className="text-sm hover:text-[#D4A373] transition-colors" data-testid="footer-email-link">training@kheirontherapy.com</a>
        <p className="text-sm mt-2">Remote or in person · Courses year-round</p>
      </div>
    </div>
    <div style={{ borderTop: "1px solid #3A332D" }}>
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-14 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs" style={{ color: "#B5AB9F" }}>
        <span>© 2026 Kheiron Therapy</span>
        <span>Approved for clinicians only · CPD-aligned</span>
      </div>
    </div>
  </footer>
);
